import React from 'react';

import useProfile from '@/hooks/useProfile';

import { TPriorityResponse } from '@/services/requests/Priority/types';

import { RecommendationFetch } from './RecommendationFetch';

const Recommendation = () => {
  const {
    profile: { profiles, place, channel },
  } = useProfile();

  const getTagId = (item: TPriorityResponse) => {
    return `recsys_templates_${item.recommendation_type.toLocaleLowerCase()}`;
  };

  return (
    <>
      {profiles.map(item => (
        <div key={item.id} id={getTagId(item)} data-testid="showcase">
          <RecommendationFetch
            key={item.id}
            id={item.id}
            place={place}
            channel={channel}
            template={item.template}
            layout={item.layout}
            type={item.recommendation_type}
            supportGeolocation={item.support_geolocation}
          />
        </div>
      ))}
    </>
  );
};

export default Recommendation;
